import { useState } from "react";
import axios from "axios";
import "./Dashboard.css";

const API_BASE = process.env.REACT_APP_API_BASE ;

export default function Dashboard() {
  const [form, setForm] = useState({
    name: "",
    description: "",
    price: "",
    quantity: "",      // ✅ added
    color: "",         // ✅ changed from colors
    sizes: "",
    style: "short_sleeve", // ✅ added
    images: [],
    is_active: true,
  });

  const [imagePreviews, setImagePreviews] = useState([]);
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState({ message: "", type: "" });

  /* ===============================
     HANDLE INPUT
  =============================== */
  const handleChange = (e) => {
    const { name, value, files, type, checked } = e.target;

    if (name === "images" && files) {
      const imgs = Array.from(files);
      setForm({ ...form, images: imgs });
      setImagePreviews(imgs.map((f) => URL.createObjectURL(f)));
    } else if (type === "checkbox") {
      setForm({ ...form, [name]: checked });
    } else {
      setForm({ ...form, [name]: value });
    }
  };

  const handleDiscardImage = (index) => {
    const imgs = [...form.images];
    const previews = [...imagePreviews];
    imgs.splice(index, 1);
    previews.splice(index, 1);
    setForm({ ...form, images: imgs });
    setImagePreviews(previews);
  };

  const showToast = (message, type = "success") => {
    setToast({ message, type });
    setTimeout(() => setToast({ message: "", type: "" }), 3000);
  };

  /* ===============================
     SUBMIT
  =============================== */
  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem("access");

    if (!token) {
      showToast("Authentication required. Please sign in.", "error");
      return;
    }

    const data = new FormData();
    data.append("name", form.name);
    data.append("description", form.description);
    data.append("price", form.price);
    data.append("quantity", form.quantity);  // ✅ added
    data.append("color", form.color);        // ✅ fixed
    data.append("style", form.style);        // ✅ added
    data.append("is_active", form.is_active);

    data.append(
      "sizes",
      JSON.stringify(
        form.sizes
          .split(",")
          .map((s) => s.trim())
          .filter(Boolean)
      )
    );

    form.images.forEach((img) => data.append("images", img));

    try {
      setLoading(true);

      await axios.post(`${API_BASE}/products/create/`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      showToast("Product created successfully!");

      setForm({
        name: "",
        description: "",
        price: "",
        quantity: "",
        color: "",
        sizes: "",
        style: "short_sleeve",
        images: [],
        is_active: true,
      });

      setImagePreviews([]);
    } catch (err) {
      console.error("Product creation error:", err);

      const msg =
        err.response?.data?.detail ||
        Object.values(err.response?.data || {})[0] ||
        "Failed to create product";

      showToast(msg, "error");
    } finally {
      setLoading(false);
    }
  };

  /* ===============================
     UI
  =============================== */
  return (
    <div className="create-product">
      <h2>Create Product</h2>

      <form onSubmit={handleSubmit}>
        <input
          name="name"
          placeholder="Product name"
          value={form.name}
          onChange={handleChange}
          required
        />

        <textarea
          name="description"
          placeholder="Description"
          value={form.description}
          onChange={handleChange}
        />

        <input
          name="price"
          type="number"
          step="0.01"
          placeholder="Price"
          value={form.price}
          onChange={handleChange}
          required
        />

        {/* ✅ Quantity input added */}
        <input
          name="quantity"
          type="number"
          placeholder="Quantity"
          value={form.quantity}
          onChange={handleChange}
          required
        />

        {/* ✅ Color field fixed */}
        <input
          name="color"
          placeholder="Color (Red)"
          value={form.color}
          onChange={handleChange}
          required
        />

        <input
          name="sizes"
          placeholder="Sizes (S, M, L, XL)"
          value={form.sizes}
          onChange={handleChange}
        />

        {/* ✅ Style dropdown added */}
        <select
          name="style"
          value={form.style}
          onChange={handleChange}
        >
          <option value="short_sleeve">Short Sleeve</option>
          <option value="full_sleeve">Full Sleeve</option>
          <option value="sleeveless">Other Top</option>
        </select>

        <input
          type="file"
          name="images"
          accept="image/*"
          multiple
          onChange={handleChange}
        />

        <div className="preview-grid">
          {imagePreviews.map((src, idx) => (
            <div key={idx} className="preview-container">
              <img src={src} alt="preview" />
              <button type="button" onClick={() => handleDiscardImage(idx)}>
                ×
              </button>
            </div>
          ))}
        </div>

        <label className="checkbox-group">
          <input
            type="checkbox"
            name="is_active"
            checked={form.is_active}
            onChange={handleChange}
          />
          Active
        </label>

        <button type="submit" disabled={loading}>
          {loading ? "Creating..." : "Create Product"}
        </button>
      </form>

      {toast.message && (
        <div className={`toast ${toast.type}`}>{toast.message}</div>
      )}
    </div>
  );
}